import { defineComponent as _defineComponent } from 'vue'
import {
  ReviewStep,
  ContentDisplay,
  ListDisplay,
  HeadingDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { ProfitPreview } from '@/modules/trade/services/profit';

interface Props {
  profitInfo: ProfitPreview;
  isLoading: boolean;
}

interface EmitEvents {
  (event: 'click'): void;
  (event: 'back'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfitReview',
  props: {
    profitInfo: null,
    isLoading: { type: Boolean }
  },
  emits: ["click", "back"],
  setup(__props: any) {

const props = __props as {
  profitInfo: ProfitPreview;
  isLoading: boolean;
}





function getLocalDate() {
  return new Date().toLocaleDateString();
}

return { __sfc: true,props, getLocalDate, ReviewStep, ContentDisplay, ListDisplay, HeadingDisplay, ButtonContainer, ButtonPrimary }
}

})